import { FC, useEffect } from 'react'
import { useStoreState, useStoreDispatch, actionTypes } from '@/store'
import { Navigate } from 'react-router-dom'
import { DotLoading, AutoCenter } from 'antd-mobile'

export const withAuth = (Component: FC) => {
  return props => {
    const { user }: any = useStoreState();
    const dispatch = useStoreDispatch();

    // 海外版本：未登录时触发登录弹框
    useEffect(() => {
      if (process.env.REACT_APP_IDN_ENV === 'hw' && !user.isLogin) {
        dispatch({ type: actionTypes.SET_HW_LOGIN_MODAL, payload: true });
      }
    }, [user.isLogin, dispatch]);

    if (!user.isLogin) {
      // 海外版本：显示 Loading，等待 Layout 的登录弹框
      if (process.env.REACT_APP_IDN_ENV === 'hw') {
        return (
          <div style={{ 
            minHeight: '100vh', 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'center' 
          }}>
            <AutoCenter>
              <DotLoading color='primary' />
            </AutoCenter>
          </div>
        );
      }
      
      // 国内版本：跳转到登录页
      return <Navigate to={'/login'} replace />;
    }

    return <Component {...props} />
  }
}
